import type {
  AdminOverlayDefinition,
  AdminViewDefinition,
} from "../../components/admin-components.js";
import { card, drawer, withDrawer } from "../_shared/overlay-definition-helpers.js";

export const usageOverlayViews: AdminViewDefinition[] = [
  withDrawer("usage-detail", "store-detail-usage", usageDetailDrawer()),
];

function usageDetailDrawer(): AdminOverlayDefinition {
  return drawer(
    "Detailed usage unavailable",
    "A live usage-detail endpoint is not implemented yet.",
    [
      card("Current status", [
        "The Admin usage API currently returns aggregate usage totals only.",
        "This drawer intentionally does not show sample service, cost, or capacity rows.",
      ]),
      card("Required backend contract", [
        "Store or global usage scope",
        "Metric period",
        "Safe service-level usage rows",
        "Provider units from backend records",
      ]),
    ],
  );
}
